import * as React from 'react';
import { Status } from '../Reducers/Status';
import { PageLayoutProps } from '../Pages/PageLayoutProps';
import Log from 'src/Common/Utilities/Log';
import App from '../../App';
import WaveReport from 'src/dashboard/WaveReport';
import { useWebVitalsRouteTracking } from 'src/utils/webVitalsTracker';
import { useLocation } from 'react-router-dom';

const telemetry = Log.getInstance();

// tslint:disable-next-line:no-any
declare const window: any;

export interface PageLayoutModel {
  location?: Location;
  environmentSettingsStatus?: Status;
  applicationContextStatus?: Status;
  localizedStringsStatus?: Status;
  applicationContextCulture?: string;
  localizedStringsCulture?: string;
  applicationContextAppInsightId?: string;
  complianceMgrShowCondition?: boolean;
}

interface PageLayoutState {
  hasLoadedEnoughStateToShowTheApp: boolean;
  showAgreement: boolean;
  showMSADialog: boolean;
  searchKeyword: string;
  showErrorDialog: boolean;
  path: string;
}

export class PageLayoutComponent extends React.Component<PageLayoutProps, PageLayoutState> {
  constructor(props: PageLayoutProps) {
    super(props);
    window.stpPageLayoutComponent = this;
    this.state = {
      hasLoadedEnoughStateToShowTheApp: false,
      showAgreement: false,
      searchKeyword: '',
      showMSADialog: false,
      showErrorDialog: false,
      path: window.location.pathname,
    };

    telemetry.info('PageLayout.constructor was called');

    telemetry.info('PageLayout.constructor is exiting');
  }

  render() {
    return <div className='pageLayout'>{<App />}</div>;
  }
}

const PageLayout = (props: PageLayoutProps) => {
  const location = useLocation();
  useWebVitalsRouteTracking(location.pathname);

  return (
    <div id='PageLayoutNext'>
      <PageLayoutComponent {...props} />
    </div>
  );
};

export default PageLayout;
// Generated by GitHub Copilot | Updated on: 2026-05-19 | 5 lines modified | Added Web Vitals route tracking integration via useLocation hook
